module.exports = __webpack_public_path__ + "static/media/subheader.200adca7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/subheader.jpeg
// module id = 473
// module chunks = 21